// Bootstrap entry for Module Federation
// This file is the webpack entry point - it imports the main app asynchronously
// allowing webpack to initialize shared modules before executing the app

import('./index');

// Export to make this a module (required for isolatedModules)
export {};
